const links = [
    {
      label: "Home",
      url: "/",
    },
    {
      label: "Sobre Mim",
      url: "/about/",
    },
    {
        label: "Portfólio",
        url: "https://fbs-dev.netlify.app",
      },
  ]

  export default links
